'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogDescription, DialogTitle, Heading, Text } from '@jaaq/hub-ui';
import { CirclePlay } from 'lucide-react';
import type { ReactElement } from 'react';
import type { Variant } from '#lib/steps/state';
type ExplainerModalProps = {
  variant: Variant;
  onClose: () => void;
  /** Optional video embed URL (YouTube /embed/ID or direct mp4). Shows a placeholder when omitted. */
  videoSrc?: string;
};
type VariantCopy = {
  title: string;
  subtitle: string;
};
const COPY: Record<Variant, VariantCopy> = {
  hosted: {
    title: 'JAAQ Hosted Explainer',
    subtitle: 'A dedicated, branded JAAQ experience at your own subdomain.'
  },
  embedded: {
    title: 'JAAQ Embedded Explainer',
    subtitle: 'Integrate JAAQ directly into your app or website via SDK/API.'
  }
};
const isEmbeddedPlayer = (src: string): boolean => src.includes('youtube') || src.includes('youtu.be') || src.includes('vimeo');
export const ExplainerModal = t0 => {
  const $ = _c(18);
  const {
    variant,
    onClose,
    videoSrc
  } = t0;
  const {
    title,
    subtitle
  } = COPY[variant];
  let t1;
  if ($[0] !== onClose) {
    t1 = open => {
      if (open) {
        return;
      }
      onClose();
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title || $[3] !== videoSrc) {
    t2 = <div className="relative aspect-video bg-surface-inverse">{videoSrc ? isEmbeddedPlayer(videoSrc) ? <iframe src={videoSrc} title={title} allow="autoplay; fullscreen" allowFullScreen={true} className="absolute inset-0 size-full" /> : <video src={videoSrc} controls={true} autoPlay={true} className="absolute inset-0 size-full object-contain" /> : <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 text-fg-inverse"><CirclePlay className="size-16 opacity-60 text-fg-inverse" strokeWidth={1.5} /><Heading level={2} variant="subtitle" tone="inverse">{title}</Heading><Text tone="inverse" muted={true}>Video coming soon</Text></div>}</div>;
    $[2] = title;
    $[3] = videoSrc;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title) {
    t3 = <DialogTitle className="font-bold text-sm uppercase tracking-tight">{title}</DialogTitle>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== subtitle) {
    t4 = <DialogDescription className="mt-1 text-2xs text-black/60 leading-5">{subtitle}</DialogDescription>;
    $[7] = subtitle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="px-6 py-5 border-t border-border">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <DialogContent showClose={true} className="max-w-3xl overflow-hidden rounded-[10px] p-0">{t2}{t5}</DialogContent>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t6) {
    t7 = <Dialog open={true} onOpenChange={t1}>{t6}</Dialog>;
    $[15] = t1;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};